(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3565,682],{

/***/ 3565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _styles_PriceList_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6083);
/* harmony import */ var _styles_PriceList_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_PriceList_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _public_logo_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3476);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4215);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1555);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _assets_images_second_bg_png__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(292);
/* harmony import */ var _helpers_imageHelpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(38);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var IcDownload = function IcDownload(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("path", {
      d: "M15.76 22.25H9.24c-4.91 0-7.01-2.1-7.01-7.01v-.13c0-4.44 1.75-6.58 5.67-6.95.4-.03.78.27.82.68.04.41-.26.78-.68.82-3.14.29-4.31 1.77-4.31 5.46v.13c0 4.07 1.44 5.51 5.51 5.51h6.52c4.07 0 5.51-1.44 5.51-5.51v-.13c0-3.71-1.19-5.19-4.39-5.46a.75.75 0 0 1-.68-.81c.04-.41.39-.72.81-.68 3.98.34 5.76 2.49 5.76 6.96v.13c0 4.89-2.1 6.99-7.01 6.99Z",
      fill: "#0E181F"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("path", {
      d: "M12.5 15.63c-.41 0-.75-.34-.75-.75V2c0-.41.34-.75.75-.75s.75.34.75.75v12.88c0 .42-.34.75-.75.75Z",
      fill: "#0E181F"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("path", {
      d: "M12.5 16.75c-.19 0-.38-.07-.53-.22l-3.35-3.35a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.82 2.82 2.82-2.82c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-3.35 3.35c-.15.15-.34.22-.53.22Z",
      fill: "#0E181F"
    })]
  }));
};

IcDownload.defaultProps = {
  width: "25",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};






var Index = function Index(_ref) {
  var _data$posts, _priceListSectionData, _priceListSectionData2, _priceListSectionData3, _priceListSectionData4, _priceListSectionData5, _priceListSectionData6, _priceListSectionData7, _priceListSectionData8, _priceListSectionData9, _priceListSectionData10, _priceListSectionData11, _priceListSectionData12, _priceListSectionData13, _priceListSectionData14, _priceListSectionData15, _priceListSectionData16, _priceListSectionData17;

  var data = _ref.data;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)(),
      locale = _useRouter.locale;

  var dir = locale === "ar" ? "rtl" : "ltr";
  var isRtl = locale === "ar";
  var priceListSectionData = data === null || data === void 0 ? void 0 : (_data$posts = data.posts) === null || _data$posts === void 0 ? void 0 : _data$posts[0];
  var ctaText = priceListSectionData === null || priceListSectionData === void 0 ? void 0 : (_priceListSectionData = priceListSectionData.data) === null || _priceListSectionData === void 0 ? void 0 : (_priceListSectionData2 = _priceListSectionData.cta) === null || _priceListSectionData2 === void 0 ? void 0 : _priceListSectionData2[locale];
  var ctaUrl = priceListSectionData === null || priceListSectionData === void 0 ? void 0 : (_priceListSectionData3 = priceListSectionData.data) === null || _priceListSectionData3 === void 0 ? void 0 : (_priceListSectionData4 = _priceListSectionData3.ctaUrl) === null || _priceListSectionData4 === void 0 ? void 0 : (_priceListSectionData5 = _priceListSectionData4.replace(/^`|`$/g, "")) === null || _priceListSectionData5 === void 0 ? void 0 : _priceListSectionData5.trim();
  var isExternalCta = /^https?:\/\//i.test(ctaUrl || "");
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
    className: (_styles_PriceList_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["price-list"]),
    style: {
      backgroundImage: "url(".concat(_assets_images_second_bg_png__WEBPACK_IMPORTED_MODULE_7__/* ["default"].src */ .Z.src, ")")
    },
    dir: dir,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__["default"], {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__["default"], {
        className: (_styles_PriceList_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["content-row"]),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__["default"], {
          lg: 6,
          xs: 12,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
            className: (_styles_PriceList_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["text-side"]),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h2", {
              className: (_styles_PriceList_module_scss__WEBPACK_IMPORTED_MODULE_9___default().title),
              children: priceListSectionData === null || priceListSectionData === void 0 ? void 0 : (_priceListSectionData6 = priceListSectionData.data) === null || _priceListSectionData6 === void 0 ? void 0 : (_priceListSectionData7 = _priceListSectionData6.title) === null || _priceListSectionData7 === void 0 ? void 0 : _priceListSectionData7[locale]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
              className: (_styles_PriceList_module_scss__WEBPACK_IMPORTED_MODULE_9___default().description),
              dangerouslySetInnerHTML: {
                __html: priceListSectionData === null || priceListSectionData === void 0 ? void 0 : (_priceListSectionData8 = priceListSectionData.data) === null || _priceListSectionData8 === void 0 ? void 0 : (_priceListSectionData9 = _priceListSectionData8.description) === null || _priceListSectionData9 === void 0 ? void 0 : _priceListSectionData9[locale]
              }
            }), ctaText && ctaUrl && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
              className: "mt-4",
              children: isExternalCta ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("a", {
                href: ctaUrl,
                target: "_blank",
                rel: "noreferrer",
                className: (_styles_PriceList_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["cta-button"]),
                children: [ctaText, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                  className: (_styles_PriceList_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["icon-circle"]),
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("svg", {
                    style: {
                      transform: isRtl ? "none" : "scaleX(-1)"
                    },
                    width: "18",
                    height: "18",
                    viewBox: "0 0 18 18",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("path", {
                      d: "M3.53577 3.53556L14.1424 14.1422",
                      stroke: "black",
                      strokeWidth: 1.5,
                      strokeLinecap: "round",
                      strokeLinejoin: "round"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("path", {
                      d: "M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553",
                      stroke: "black",
                      strokeWidth: 1.5,
                      strokeLinecap: "round",
                      strokeLinejoin: "round"
                    })]
                  })
                })]
              }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                href: ctaUrl,
                passHref: true,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("a", {
                  className: (_styles_PriceList_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["cta-button"]),
                  children: [ctaText, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                    className: (_styles_PriceList_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["icon-circle"]),
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("svg", {
                      style: {
                        transform: isRtl ? "none" : "scaleX(-1)"
                      },
                      width: "18",
                      height: "18",
                      viewBox: "0 0 18 18",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("path", {
                        d: "M3.53577 3.53556L14.1424 14.1422",
                        stroke: "black",
                        strokeWidth: 1.5,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("path", {
                        d: "M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553",
                        stroke: "black",
                        strokeWidth: 1.5,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                      })]
                    })
                  })]
                })
              })
            })]
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__["default"], {
          lg: 6,
          xs: 12,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
            className: (_styles_PriceList_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["image-collage"]),
            children: [(priceListSectionData === null || priceListSectionData === void 0 ? void 0 : (_priceListSectionData10 = priceListSectionData.data) === null || _priceListSectionData10 === void 0 ? void 0 : _priceListSectionData10.image) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
              className: (_styles_PriceList_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["collage-item"]),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: (0,_helpers_imageHelpers__WEBPACK_IMPORTED_MODULE_8__/* .buildApiUrl */ .f8)(priceListSectionData === null || priceListSectionData === void 0 ? void 0 : (_priceListSectionData11 = priceListSectionData.data) === null || _priceListSectionData11 === void 0 ? void 0 : _priceListSectionData11.image),
                alt: "collage-1",
                fill: true
              })
            }), (priceListSectionData === null || priceListSectionData === void 0 ? void 0 : (_priceListSectionData12 = priceListSectionData.data) === null || _priceListSectionData12 === void 0 ? void 0 : _priceListSectionData12.image_new) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
              className: "".concat((_styles_PriceList_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["collage-item"]), " ").concat((_styles_PriceList_module_scss__WEBPACK_IMPORTED_MODULE_9___default().large)),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: (0,_helpers_imageHelpers__WEBPACK_IMPORTED_MODULE_8__/* .buildApiUrl */ .f8)(priceListSectionData === null || priceListSectionData === void 0 ? void 0 : (_priceListSectionData13 = priceListSectionData.data) === null || _priceListSectionData13 === void 0 ? void 0 : _priceListSectionData13.image_new),
                alt: "collage-2",
                fill: true
              })
            }), (priceListSectionData === null || priceListSectionData === void 0 ? void 0 : (_priceListSectionData14 = priceListSectionData.data) === null || _priceListSectionData14 === void 0 ? void 0 : (_priceListSectionData15 = _priceListSectionData14.file) === null || _priceListSectionData15 === void 0 ? void 0 : _priceListSectionData15.name) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
              className: (_styles_PriceList_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["collage-item"]),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: (0,_helpers_imageHelpers__WEBPACK_IMPORTED_MODULE_8__/* .buildApiUrl */ .f8)(priceListSectionData === null || priceListSectionData === void 0 ? void 0 : (_priceListSectionData16 = priceListSectionData.data) === null || _priceListSectionData16 === void 0 ? void 0 : (_priceListSectionData17 = _priceListSectionData16.file) === null || _priceListSectionData17 === void 0 ? void 0 : _priceListSectionData17.name),
                alt: "collage-3",
                fill: true
              })
            })]
          })
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Index);

/***/ }),

/***/ 6083:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cta-button-white":"PriceList_cta-button-white__XiPs7","price-list":"PriceList_price-list__Y3UTF","content-row":"PriceList_content-row__zQ__u","image-collage":"PriceList_image-collage__9OAIT","collage-item":"PriceList_collage-item__BKao0","large":"PriceList_large__BYljF","text-side":"PriceList_text-side__h2D4C","title":"PriceList_title__iv6Ck","description":"PriceList_description__33RfS","cta-button":"PriceList_cta-button__nQETC","icon-circle":"PriceList_icon-circle__d99f1"};

/***/ }),

/***/ 682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





const Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  fluid = false,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'container');
  const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, fluid ? `${prefix}${suffix}` : prefix)
  });
});
Container.displayName = 'Container';
/* harmony default export */ __webpack_exports__["default"] = (Container);

/***/ })

}]);